import React, { useEffect, useRef, useState } from 'react';
import './sec9.css';
import beforeImage from './before.png';
import afterImage from './after.png';

const Sec9 = () => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [scrollProgress, setScrollProgress] = useState(0);

    const handleScroll = () => {
        const element = containerRef.current;
        if (element) {
            const rect = element.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            // Calculate opacity based on element's position in the viewport
            const visiblePart = Math.max(0, Math.min(1, (windowHeight - rect.top) / windowHeight));
            setScrollProgress(visiblePart);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Initialize on component mount
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div ref={containerRef} className="sec9-section">
            <img src={beforeImage} alt="Before" className="img-base" />
            <img src={afterImage} alt="After" className="img-overlay" style={{ opacity: scrollProgress }} />
        </div>
    );
};

export default Sec9;
